import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  GetEventCollectionRequest,
  GetEventCollectionResponse,
} from '../../content/eventCollection/event_collection_pb';

import {
  EventCollection as __EventCollection,
} from '../../content/eventCollection/event_collection_pb_service';

@Injectable({providedIn: 'root'})
export class EventCollection {

  constructor(private _ngZone: NgZone) {
  }

  getEventCollection(request: GetEventCollectionRequest): {cancel():void;close():void}&Observable<GetEventCollectionResponse>;
  getEventCollection(request: GetEventCollectionRequest, metadata: grpc.Metadata): {cancel():void;close():void}&Observable<GetEventCollectionResponse>;
  getEventCollection(request: GetEventCollectionRequest, onMessage: (message?: GetEventCollectionResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;
  getEventCollection(request: GetEventCollectionRequest, metadata: grpc.Metadata, onMessage: (message?: GetEventCollectionResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;

  getEventCollection(request: GetEventCollectionRequest, arg1?: grpc.Metadata|((message?: GetEventCollectionResponse) => void), arg2?: ((message?: GetEventCollectionResponse) => void)|((err: any) => void), arg3?: ((err: any) => void)|((code: number, msg: string|undefined, metadata: grpc.Metadata) => void), arg4?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): {cancel():void;close():void}&Observable<GetEventCollectionResponse>|void {
    let ret: any;
    let metadata: any;

    let onMessage: any;
    let onError: any;
    let onEnd: any;
    if(typeof arg1 === 'function') {
      onMessage = arg1;
      onError = arg2;
      onEnd = arg3;
    } else if(typeof arg2 === 'function') {
      metadata = arg1;
      onMessage = arg2;
      onError = arg3;
      onEnd = arg4;
    } else {
      metadata = arg1;
    }

    if(!onMessage) {
      let subject = new Subject<GetEventCollectionResponse>();
      ret = subject.asObservable();

      onMessage = (response: any) => {
        subject.next(response);
      };

      onError = (err: any) => {
        subject.error(err);
      };

      onEnd = (code: any, msg: any, metadata: any) => {
        subject.complete();
      };

    } else {
      if(!onError) {
        onError = (err: any) => console.error(err);
      }

      if(!onEnd) {
        onEnd = (code: any, msg: any, metadata: any) => {};
      }
    }

    let req = grpc.invoke(__EventCollection.GetEventCollection, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onMessage: response => this._ngZone.run(() => {
        onMessage(response);
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code == grpc.Code.OK) {
          onEnd(code, msg, metadata);
        } else {
          let err = new Error(code + ' ' + (msg||''));
          (<any>err).code = code;
          onError(err);
        }
      })
    });

    (<any>ret).close = () => {
      console.warn('[Angular Grpc] .close() is deprecated use .cancel() instead');
      return req.close();
    };
    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

